import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
import data from '../data/groceries'

const Groceries = () => {
  // eslint-disable-next-line
  const [items, setItems] = useState(data)

  return (
    <>
      <h2 className="font-bold text-4xl text-center mb-5 tracking-widest text-gray-800">
        What we deliver
      </h2>
      <section className="grid grid-cols-1 gap-7 px-5 pb-20 sm:grid-cols-2 sm:gap-4 xl:grid-cols-4">
        {items.map((item) => {
          const { id, image, title } = item

          return (
            <div key={id}>
              <img src={image} alt="Grocery card" className="mb-2" />
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-bold text-lg">{title}</p>
                </div>
                {/* <div>
                  <Link
                    to="/place-an-order"
                    className="font-bold text-white bg-blue-500 py-1 px-2 rounded-lg transition-all hover:bg-blue-800"
                  >
                    Place An Order
                  </Link>
                </div> */}
              </div>
            </div>
          )
        })}
      </section>
    </>
  )
}

export default Groceries
